import PropTypes from 'prop-types';
import React from 'react';

import CSSTransitionOnMount from 'presentation/components/lib/CSSTransitionOnMount';
import CustomIcon from 'presentation/components/icons/CustomIcon';
import { ICON_TYPES } from 'enums/configuration';
import overrideStyles from 'lib/overrideStyle';

export default function AttachmentUploadButton(props) {
  AttachmentUploadButton.propTypes = {
    hasContent: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
  };

  return (
    <CSSTransitionOnMount className="fadeAttachmentButtonIn" timeout={50}>
      <React.Fragment>
        {/* TODO: change multiple back to true when the smooch upload issue has been resolved. */}
        <HiddenInput type="file" id="gladlyFileInput" multiple={false} onChange={props.onChange} />
        <OuterWrapper
          data-aid="gladlyFileInputWrapper"
          hasContent={props.hasContent}
          tabIndex="0"
          role="button"
          onChange={props.onChange}
          onClick={handleOnClick}
          onKeyDown={handleKeyDown}
        >
          <InnerWrapper tabIndex="-1">
            <CustomIcon type={ICON_TYPES.ATTACHMENT_UPLOAD} />
          </InnerWrapper>
        </OuterWrapper>
      </React.Fragment>
    </CSSTransitionOnMount>
  );
}

function handleOnClick() {
  document.getElementById('gladlyFileInput').click();
}

function handleKeyDown(ev) {
  let charCode = ev.keyCode;
  let enterKey = 13;

  if (charCode === enterKey && !ev.shiftKey) {
    handleOnClick();
    ev.stopPropagation();
    ev.preventDefault();
    return false;
  }
}
const InnerWrapper = overrideStyles('div')`
  outline: none;
`;

const OuterWrapper = overrideStyles('div')`
  bottom: 15px;
  color: ${p => (p.hasContent ? p.theme.colors.submitArrow || p.theme.colors.brandPrimary : '#555555')};
  cursor: pointer;
  flex: 0 0 22px;
  height: 19px;
  order: 2;
  margin: 0px 17px 7px 5px;
  padding: 2px 2px 1px 2px;
  position: absolute;
  right: 2px;
  fill: #555555;
  transition: all ease 0.2s;
  width: 22px;

  transition: transform 0.5s;
  ${p => (p.hasContent ? 'transform: translate(-40px);' : null)}
`;

const HiddenInput = overrideStyles('input')`
  display: none;
  height: 0px;
  width: 0px;
`;
